// HMDA Information related Redux Constants
export const [
  HMDA_INFO_SAVE
] = [
  "HMDA_INFO_SAVE"
];
